import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
} from "reactstrap";
import "./modelcss.css";

export default function InsertAddIncomeModel({
  OnToggle,
  view,
  onUpdateHeadMap,
  updateCategory,
  cancel,
  values,
}) {
  return (
    <div>
      <Modal isOpen={view} toggle={OnToggle} fullscreen={"false"}>
        <ModalBody>
          <Row xs="4">
            <Col>Date</Col>
            <Col>
              <Input
                type="date"
                name="date"
                id="date"
                onChange={onUpdateHeadMap}
                value={values.date || ""}
              />
            </Col>
            <Col>Category</Col>

            <Col>
              <Input
                type="select"
                name="category"
                id="category"
                onChange={onUpdateHeadMap}
                value={values.type || ""}
              >
                <option value="0">Select</option>
              </Input>
            </Col>
          </Row>
          <Row xs="4">
            <Col>Amount</Col>
            <Col>
              <Input
                type="text"
                name="amount"
                id="amount"
                onChange={onUpdateHeadMap}
                value={values.amount || ""}
              />
            </Col>
            <Col />
            <Col />
          </Row>
          <Row xs="4">
            <Col>Description</Col>
            <Col>
              <Input
                type="textarea"
                name="desc"
                id="desc"
                onChange={onUpdateHeadMap}
                value={values.desc || ""}
              />
            </Col>
            <Col />
            <Col />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={updateCategory}>
            Save
          </Button>
          <Button color="secondary" onClick={cancel}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/InserAddIncomeModel.js